import { Footer, Logo, Navigation } from '@/components/NewSidebar/components';
import { useUserSettings } from '@/state/user-settings/UserSettingsProvider';
import styled from '@emotion/styled';
import { WhatsNew } from './components/Footer/WhatsNew';

export const SIDEBAR_WIDTH = '255px';

const SideBarContainer = styled.aside`
    display: flex;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors.white};
    min-width: ${SIDEBAR_WIDTH};
    max-width: ${SIDEBAR_WIDTH};
    height: 100%;
    z-index: 20;
    justify-content: space-between;
`;

const ScrollArea = styled.div`
    overflow-y: auto;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
`;

const MenuItemsContainer = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const Sidebar = () => {
    const { userSettings } = useUserSettings();

    const isOnBoardingDone = !!userSettings?.features?.onBoarding?.finished;
    const sideBarId = isOnBoardingDone ? 'on-boarding-done' : 'temp-id';

    return (
        <SideBarContainer id={sideBarId}>
            <ScrollArea>
                <Logo />
                <MenuItemsContainer>
                    <Navigation />
                    <WhatsNew />
                </MenuItemsContainer>
            </ScrollArea>
            <Footer />
        </SideBarContainer>
    );
};
